import { gql } from '@apollo/client'

export const BILLING_PERIOD_FRAGMENT = gql`
  fragment BillingPeriod on BillingPeriod {
    startDate
    endDate
  }
`
